/* CUSTOMIZED COPY OF yup/lib/locale */

import i18n from "i18next";
import { type LocaleObject, printValue } from "yup";

export const YupLocaleObject: LocaleObject = {
    mixed: {
        default: i18n.t("yupDefaultValidation.mixed.default"),
        required: i18n.t("yupDefaultValidation.mixed.required"),
        oneOf: i18n.t("yupDefaultValidation.mixed.oneOf"),
        notOneOf: i18n.t("yupDefaultValidation.mixed.notOneOf"),
        defined: i18n.t("yupDefaultValidation.mixed.defined"),
        notType: ({ path, type, value, originalValue }) => {
            const isCast = originalValue != null && originalValue !== value;
            let msg =
                `${path} musí být typu \`${type}\`` +
                `ale konečná hodnota byla: \`${printValue(value, true)}\`` +
                (isCast ? ` (z hodnoty \`${printValue(originalValue, true)}\`).` : ".");

            if (value === null) {
                msg += `\n Pokud je "null" zamýšleno jako hodnota prázného pole, označte ho jako \`.nullable()\`.`;
            }

            return msg;
        },
    },
    string: {
        length: i18n.t("yupDefaultValidation.string.length"),
        min: i18n.t("yupDefaultValidation.string.min"),
        max: i18n.t("yupDefaultValidation.string.max"),
        matches: i18n.t("yupDefaultValidation.string.matches"),
        email: i18n.t("yupDefaultValidation.string.email"),
        url: i18n.t("yupDefaultValidation.string.url"),
        uuid: i18n.t("yupDefaultValidation.string.uuid"),
        trim: i18n.t("yupDefaultValidation.string.trim"),
        lowercase: i18n.t("yupDefaultValidation.string.lowercase"),
        uppercase: i18n.t("yupDefaultValidation.string.uppercase"),
    },
    number: {
        min: i18n.t("yupDefaultValidation.number.min"),
        max: i18n.t("yupDefaultValidation.number.max"),
        lessThan: i18n.t("yupDefaultValidation.number.lessThan"),
        moreThan: i18n.t("yupDefaultValidation.number.moreThan"),
        positive: i18n.t("yupDefaultValidation.number.positive"),
        negative: i18n.t("yupDefaultValidation.number.negative"),
        integer: i18n.t("yupDefaultValidation.number.integer"),
    },
    date: {
        min: i18n.t("yupDefaultValidation.date.min"),
        max: i18n.t("yupDefaultValidation.date.max"),
    },
    boolean: {
        isValue: i18n.t("yupDefaultValidation.boolean.isValue"),
    },
    object: {
        noUnknown: i18n.t("yupDefaultValidation.object.noUnknown"),
    },
    array: {
        min: i18n.t("yupDefaultValidation.array.min"),
        max: i18n.t("yupDefaultValidation.array.max"),
        length: i18n.t("yupDefaultValidation.array.length"),
    },
};
